import { combineEpics } from 'redux-observable';
import type { State } from '../state/types';
import { epic as addCategoriesForArticleEpic } from './add-categories-for-article';
import { epic as addLabelsToArticleEpic } from './add-labels-to-article';
import { epic as browseArticlesEpic } from './browse-knowledge';
import { epic as fetchAppLinkEpic } from './fetch-applink';
import { epic as fetchAppLinksEpic } from './fetch-applinks';
import { epic as fetchArticleEpic } from './fetch-article';
import { epic as fetchArticleEditEpic } from './fetch-article-edit-permission';
import { epic as fetchCategoriesEpic } from './fetch-categories';
import { epic as fetchKbHubEpic } from './fetch-knowledge-hub';
import { epic as fetchLinkedSpaces } from './fetch-linked-spaces';
import { epic as removeLabelFromArticleEpic } from './remove-labels-from-article';
import { epic as searchArticlesEpic } from './search-articles';
import { epic as updateCategoriesForArticleEpic } from './update-categories-for-article';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default combineEpics<any, State>(
	searchArticlesEpic,
	fetchKbHubEpic,
	fetchArticleEpic,
	fetchArticleEditEpic,
	fetchCategoriesEpic,
	browseArticlesEpic,
	addCategoriesForArticleEpic,
	updateCategoriesForArticleEpic,
	fetchLinkedSpaces,
	fetchAppLinkEpic,
	fetchAppLinksEpic,
	addLabelsToArticleEpic,
	removeLabelFromArticleEpic,
);
